import { FC, useState } from 'react';
import { Button, Modal, Typography } from 'antd';
import {
  PlanResponse,
  SubscribeResponse,
  useHandleSubscription,
} from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { Col, Row } from '@/shared/ui';

type Props = {
  open: boolean;
  onSuccess: () => void;
  onCancel: () => void;
  price: PlanResponse['price'];
};

const { Title, Paragraph } = Typography;

export const ProPlanMonthlyUpgradeModal: FC<Props> = ({
  open,
  onSuccess,
  onCancel,
  price,
}) => {
  const { activeOrganization } = useRouterContext();

  const [upgradeMonthlyLink, setUpgradeMonthlyLink] = useState('');

  const { isLoading: linkLoading } = useHandleSubscription(
    {
      pathParams: {
        planType: 'Pro',
        organizationId: activeOrganization?.id!,
        interval: 'Monthly',
      },
    },
    {
      enabled: Boolean(
        activeOrganization?.id && open && upgradeMonthlyLink === '',
      ),
      onSuccess(data: SubscribeResponse) {
        open && setUpgradeMonthlyLink(data.url);
      },
    },
  );

  const handleLinkClicked = () => {
    window.open(upgradeMonthlyLink, '_blank')?.focus();
    onSuccess();
  };

  return (
    <Modal
      title={
        <Col
          alignItems="flex-start"
          style={{ margin: '10px 0', width: '100%' }}
        >
          <Title level={4} style={{ lineHeight: 1, marginTop: 15 }}>
            Upgrade to Pro plan
          </Title>
        </Col>
      }
      destroyOnClose
      width={450}
      open={open}
      footer={null}
      style={{ maxWidth: '90%' }}
      onCancel={onCancel}
    >
      <Paragraph style={{ marginBottom: 20 }}>
        You are about to upgrade to Pro plan. Clicking on a{' '}
        <strong>Go to payment page</strong> button you will be redirected to
        payment page where you will add your payment details and confirm your
        payment.
      </Paragraph>
      <div>
        <Paragraph style={{ marginTop: 20 }}>
          <span>
            You will be charged{' '}
            <strong>
              $
              {
                price.find((price) => price.billingInterval === 'Monthly')
                  ?.value
              }{' '}
              every month{' '}
            </strong>
            until you cancel.
          </span>
        </Paragraph>
      </div>
      <Paragraph>Do you want to continue?</Paragraph>
      <Row justifyContent="flex-end" gap={15} style={{ marginTop: 30 }}>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          size="large"
          loading={linkLoading}
          onClick={handleLinkClicked}
        >
          Go to payment page
        </Button>
      </Row>
    </Modal>
  );
};
